module.exports = __webpack_public_path__ + "img/invoices.9c8efc57.svg";